import React, { FC } from 'react';
import useAuth from 'src/hooks/useAuth';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { Button } from '@mui/material';

const ImpersonatedUserBanner: FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="impersonator-banner-container">
      <div className="impersonator-banner">
        <div className="impersonator-banner-content">
          <SupervisedUserCircleIcon fontSize={'large'} />
          <div className="impersonator-banner-content">
            You ({user.impersonator.name}) are currently working on behalf of{' '}
            {`${user.first_name} ${user.last_name}`}
          </div>
          <Button variant="outlined" color={'info'} onClick={logout}>
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonatedUserBanner;
